<template>
  <div>
    <div v-if="versionIdList.length === 0">
      <a-empty description="暂无相关契约版本" />
    </div>
    <div v-else class="conten-box">
      <div class="left-panel" :span="8">
        <a-card size="small">
          <template slot="title">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <div>契约列表 ({{ apiVersionList.length }})</div>
              <div>
                <a-input v-model="searchValue" placeholder="搜索" />
              </div>
            </div>
          </template>
          <div class="card-content">
            <a-card v-for="(item, idx) in filteredApiVersionList" :key="idx" hoverable size="small" class="api-item-box-card" :class="{ 'api-item-active': selectedItem && selectedItem.versionId === item.versionId }" @click="handleClick(item)">
              <div slot="title">
                <div style="display: flex; align-items: center">
                  <span style="max-width: 200px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"> {{ item.name }} </span>
                </div>
              </div>
              <div slot="extra">
                <div style="height: 20px">
                  <a-tag v-if="item.tag" class="change-person" :color="item.tag === '新建' ? '#87d068' : '#108ee9'" style="margin: 0 4px">
                    {{ item.tag }}
                  </a-tag>
                  <a-space v-show="!!taskId" class="ext-button">
                    <a-button type="link" icon="delete" size="small" class="delete-btn" @click.stop="handleDelete(item)">解除</a-button>
                    <a-button type="link" icon="reload" size="small" class="delete-btn" @click.stop="handleUpdate(item)">更新</a-button>
                  </a-space>
                </div>
              </div>
              <div style="display: flex; align-items: flex-start">
                <div :style="{ color: methodColor(item.method), marginRight: '8px', flexShrink: 0 }">{{ item.method }}</div>
                <div style="word-break: break-word; overflow-wrap: break-word">{{ item.path || '' }}</div>
              </div>
              <div v-if="type === 'story'" style="margin-top: 10px">任务名称： {{ item.taskName }}</div>
              <div style="margin-top: 15px; display: flex; align-items: center; justify-content: space-between">
                <a-tag> {{ item.projectName }} </a-tag>
                <div>变更人：<user-profiles :value="[item.createBy]" avatar /></div>
              </div>
            </a-card>
          </div>
        </a-card>
      </div>
      <div class="right-panel">
        <div style="height: 100%">
          <iframe ref="apiFrame" style="width: 100%; height: 100%; border: none" src="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getApiVersionList, taskUpdateItem, getNvwaNewApiVersion } from '@/api/project/task';

export default {
  props: {
    type: {
      type: String,
      default: 'task' // task , story
    }
  },
  data() {
    return {
      searchValue: '',
      versionIdList: [],
      varsionObjList: [],
      apiVersionList: [],
      selectedItem: null,
      taskId: null
    };
  },
  computed: {
    filteredApiVersionList() {
      if (!this.searchValue) {
        return this.apiVersionList;
      }
      const searchValue = this.searchValue.trim().toLowerCase();
      return this.apiVersionList.filter(item => {
        return item.name.toLowerCase().includes(searchValue) || item.projectName.toLowerCase().includes(searchValue) || item.path.toLowerCase().includes(searchValue) || item.taskName.toLowerCase().includes(searchValue);
      });
    }
  },
  methods: {
    init(versionList, taskId) {
      if (this.type === 'task') {
        this.versionIdList = versionList || [];
        this.taskId = taskId;
      } else {
        this.varsionObjList = versionList || [];
        this.versionIdList = this.varsionObjList.map(item => item.id);
      }
      if (this.versionIdList.length > 0) {
        this.getApiVersionList();
      } else {
        this.apiVersionList = [];
      }
    },

    getTaskName(versionId) {
      const versionObj = this.varsionObjList.find(item => item.id === versionId);
      if (versionObj) {
        const tasks = versionObj.tasks || [];
        if (tasks.length > 0) {
          return tasks[0].name || '';
        }
      }
      return '';
    },

    /**
     * 获取契约版本列表
     */
    getApiVersionList() {
      if (this.versionIdList && this.versionIdList.length > 0) {
        getApiVersionList({ apiVersionIdList: this.versionIdList }).then(res => {
          if (res && res.result) {
            this.apiVersionList = res.result || [];
            if (this.apiVersionList.length > 0) {
              this.apiVersionList.forEach(item => {
                item.taskName = this.getTaskName(item.versionId);
              });
              this.$nextTick(() => {
                this.handleClick(this.apiVersionList[0]);
              });
            }
          } else {
            this.apiVersionList = [];
          }
        });
      }
    },
    methodColor(method) {
      if (method === 'GET') {
        return 'rgb(96,183,146)';
      } else if (method === 'POST') {
        return 'rgb(224,141,73)';
      } else if (method === 'PUT') {
        return 'rgb(81,141,238)';
      } else if (method === 'DELETE') {
        return 'rgb(232,95,51)';
      } else if (method === 'HEAD') {
        return 'rgb(81,141,238)';
      } else if (method === 'OPTIONS') {
        return 'rgb(81,141,238)';
      } else if (method === 'PATCH') {
        return 'rgb(216,68,147)';
      } else {
        return 'rgb(96,183,146)';
      }
    },

    handleClick(item) {
      this.selectedItem = item;
      const protocol = window.location.protocol;
      // 解决iframe加载问题
      this.$nextTick(() => {
        // 先将src设为空，强制重新加载
        this.$refs.apiFrame.src = '';
        const host = process.env.NODE_ENV === 'development' ? 'localhost:3100' : 'nvwa.cdfsunrise.com';
        setTimeout(() => {
          this.$refs.apiFrame.src = `${protocol}//${host}/#/apiVersion?versionId=${item.versionId}`;
        }, 50);
      });
    },

    handleUpdate(item) {
      this.$confirm({
        title: '确定更新该契约版本吗？',
        content: '更新后无法恢复，请谨慎操作。',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          getNvwaNewApiVersion({
            projectId: item.projectId,
            apiId: item.id,
            taskId: this.taskId,
            versionId: item.versionId
          }).then(res => {
            if (res && res.result) {
              const newVersionId = res.result;
              if (newVersionId === item.versionId) {
                this.$message.warning('已经是最新版本,无需更新');
                return;
              }
              this.versionIdList = this.versionIdList.map(id => (id === item.versionId ? newVersionId : id));
              taskUpdateItem({
                task_id: this.taskId,
                key: 'agreements',
                value: this.versionIdList
              }).then(res => {
                this.$emit('deleteOk');
                this.$message.success('更新成功');
              });
            } else {
              this.$message.error('更新失败');
            }
          });
        },
        onCancel: () => {
          this.$message.error('取消更新');
        }
      });
    },

    handleDelete(item) {
      this.$confirm({
        title: '确定解除该契约版本吗？',
        content: '解除后无法恢复，请谨慎操作。',
        okText: '确定',
        cancelText: '取消',
        onOk: () => {
          taskUpdateItem({
            task_id: this.taskId,
            key: 'agreements',
            value: this.versionIdList.filter(id => id !== item.versionId)
          }).then(res => {
            this.$message.success('删除成功');
            this.$emit('deleteOk');
          });
        },
        onCancel: () => {
          this.$message.error('取消删除');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
/deep/.conten-box {
  height: 700px;
  display: flex;
  > .left-panel {
    height: 100%;
    width: 400px;
    > .ant-card {
      height: 100%;
      // display: flex;
      // flex-direction: column;
      > .ant-card-body {
        // flex: 1 !important;
        height: 640px;
        overflow-y: auto;
        > .card-content {
          height: 100%;
        }

        .api-item-box-card {
          border-radius: 10px;
          margin-bottom: 15px;

          .change-person {
            display: block;
          }
          .ext-button {
            display: none;
          }
          .delete-btn {
            color: #ff4d4f;
            padding: 0;
            display: inline-block;
          }

          &:hover {
            .change-person {
              display: none;
            }

            .ext-button {
              display: flex;
            }
          }
        }

        .api-item-active {
          border: 1px solid #1890ff;
          box-shadow: 0 2px 8px rgba(24, 144, 255, 0.2);
        }
      }
    }
  }
  > .right-panel {
    flex: 1;
    height: 100%;
  }
}
</style>
